import { initializeModalButtons } from '../index/modal/modal';

document.addEventListener('DOMContentLoaded', () => {
    const addShowMoreButtonListeners = () => {
        const showMoreButtons = document.querySelectorAll('.news-show-more');

        showMoreButtons.forEach((button) => {
            button.addEventListener('click', async (event) => {
                const button = event.target;
                const section = button.closest('section');

                if (!section) {
                    console.error('Не удалось найти родительский блок секции.');
                    return;
                }

                const number = parseInt(button.getAttribute('data-number'));
                const offset = parseInt(button.getAttribute('data-offset'));
                const typeAuthor = button.getAttribute('data-type-author');

                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                    },
                    mode: 'no-cors',
                };

                const form = new FormData();
                form.append('action', 'load_more_news');
                form.append('number', number);
                form.append('offset', offset);
                form.append('author', typeAuthor);

                const params = new URLSearchParams(form);
                options.body = params;

                try {
                    let response = await fetch('/wp-admin/admin-ajax.php', options);
                    let html = await response.text();
                    if (html) {
                        const newsList = section.querySelector('.news-content-list');
                        if (newsList) {
                            newsList.innerHTML = html;

                            addShowMoreButtonListeners();
                        }

                        const newShowMoreBtn = section.querySelector('.news-show-more');
                        if (newShowMoreBtn) {
                            const newOffset = offset + number;
                            newShowMoreBtn.setAttribute('data-offset', newOffset);
                        }

                        initializeModalButtons();
                    }
                } catch (error) {
                    console.error('Ошибка при загрузке новостей:', error);
                }
            });
        });
    };

    addShowMoreButtonListeners();
});